var React = require('react');

function TriangleStroke (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M55.9688 52.3937L1.11072 52.3937L28.5398 1.36284L55.9688 52.3937Z","stroke":"currentColor","strokeWidth":"2"}));
}

TriangleStroke.defaultProps = {"viewBox":"0 0 57 53","fill":"none"};

module.exports = TriangleStroke;

TriangleStroke.default = TriangleStroke;
